import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateTiposIVA () {
  return [
    {
      id: 'General',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.general'),
      value: 21
    },
    {
      id: 'Reducido',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.reducido'),
      value: 10
    },
    {
      id: 'Superreducido',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.superreducido'),
      value: 4
    },
  ]
}

function GenerateTiposIGIC () {
  return [
    {
      id: 'General',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.general'),
      value: 7
    },
    {
      id: 'Reducido',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.reducido'),
      value: 3
    },
    {
      id: 'Superreducido',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.superreducido'),
      value: 0
    },
    {
      id: 'Tipo cero',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.tipo_0'),
      value: 0
    },
    {
      id: 'Incrementado',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.incrementado'),
      value: 9.5
    },
    {
      id: 'Especial incrementado',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.especial_incrementado'),
      value: 15
    },
    {
      id: 'Especial',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.especial'),
      value: 20
    },
  ]
}

function GenerateTiposIPSI () {
  return [
    {
      id: 'General',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.general'),
      value: 10
    },
    {
      id: 'Reducido',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.reducido'),
      value: 4
    },
    {
      id: 'Superreducido',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.superreducido'),
      value: 0.5
    },
    {
      id: 'Tipo 1',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.tipo_1'),
      value: 1 
    },
    {
      id: 'Tipo 2',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.tipo_2'),
      value: 2
    },
    {
      id: 'Tipo 8',
      name: i18n.t('invoices.invoices_issuing.tipos_asociados.tipo_8'),
      value: 8
    },
  ]
}

export function TIPOS_ASOCIADOS_IVA (state) {
  return configHelper.getConfig(state, 'TIPOS_ASOCIADOS_IVA', GenerateTiposIVA)
}

export function TIPOS_ASOCIADOS_IGIC (state) {
  return configHelper.getConfig(state, 'TIPOS_ASOCIADOS_IGIC', GenerateTiposIGIC)
}

export function TIPOS_ASOCIADOS_IPSI (state) {
  return configHelper.getConfig(state, 'TIPOS_ASOCIADOS_IPSI', GenerateTiposIPSI)
}
